import {
  GroundIcon,
  PlaneIcon,
  UsaIcon,
  TurkeyIcon,
  ChinaIcon,
  GreeceIcon,
  ShipIcon,
} from "@/components/assets/icons";
import { Country, TransportationMode, TransportationType } from "@/enums";
import { IDeliveryType, IDetailInput } from "../shipping-calculator/types";

export const deliveryTypesListUZ: IDeliveryType[] = [
  {
    id: TransportationMode.AIR,
    name: TransportationType.EXPRESS,
    priceLabel: "express_price_uz",
    deliveryTime: "calc_express_days",
    icon: PlaneIcon,
    type: TransportationType.EXPRESS,
  },
  {
    id: TransportationMode.SEA,
    name: TransportationType.ECONOMY,
    priceLabel: "economy_price_uz",
    deliveryTime: "calc_economy_days",
    icon: PlaneIcon,
    type: TransportationType.ECONOMY,
  },
];

export const deliveryTypesList: IDeliveryType[] = [
  {
    id: TransportationMode.AIR,
    name: TransportationType.AIR,
    deliveryTime: "delivery_time_uz_air",
    icon: PlaneIcon,
    type: TransportationType.AIR,
  },
  {
    id: TransportationMode.GROUND,
    name: TransportationType.GROUND,
    deliveryTime: "delivery_time_uz_ground",
    icon: GroundIcon,
    type: TransportationType.GROUND,
  },
  {
    id: TransportationMode.SEA,
    name: TransportationType.SEA,
    deliveryTime: "delivery_time_ge_sea",
    icon: ShipIcon,
    type: TransportationType.SEA,
  },
];

export const deliveryTypesListUKR: IDeliveryType[] = [
  {
    id: TransportationMode.AIR,
    name: TransportationType.AIR,
    deliveryTime: "delivery_time_ukr_air",
    icon: PlaneIcon,
    type: TransportationType.AIR,
  },
  {
    id: TransportationMode.SEA,
    name: TransportationType.SEA,
    deliveryTime: "delivery_time_ukr_sea",
    icon: ShipIcon,
    type: TransportationType.SEA,
  },
  {
    id: TransportationMode.ECONOMY,
    name: TransportationType.ECONOMY,
    deliveryTime: "delivery_time_ukr_economy",
    icon: ShipIcon,
    type: TransportationType.ECONOMY,
  },
];

export const detailInputsList: IDetailInput[] = [
  {
    label: "weight",
    value: "weight",
  },
  {
    label: "cost_in_USD",
    value: "cost",
  },
  {
    label: "length",
    value: "length",
  },
  {
    label: "width",
    value: "width",
  },
  {
    label: "height",
    value: "height",
  },
];

export const detailInputsListUK: IDetailInput[] = [
  {
    label: "weight",
    value: "weight",
  },
  {
    label: "cost_in_USD",
    value: "cost",
  },
];

export const countriesList = [
  {
    id: Country.USA,
    icon: UsaIcon,
  },
  {
    id: Country.TURKEY,
    icon: TurkeyIcon,
  },
  {
    id: Country.CHINA_LAND,
    icon: ChinaIcon,
  },
  {
    id: Country.CHINA_AIR,
    icon: ChinaIcon,
  },
  {
    id: Country.GREECE,
    icon: GreeceIcon,
  },
];

export const addressDetailsGlobal = [
  {
    label: "address_line_1",
    value: "addressLine1",
  },
  {
    label: "address_line_2",
    value: "addressLine2",
  },
  {
    label: "city",
    value: "city",
  },
  {
    label: "state",
    value: "state",
  },
  {
    label: "zip_code",
    value: "zip",
  },
  {
    label: "country",
    value: "countryName",
  },
  {
    label: "phone",
    value: "phone",
  },
];

export const addressDetailsChina = [
  { label: "province", value: "province" },
  { label: "city", value: "city" },
  { label: "street", value: "street" },
  { label: "district", value: "district" },
  { label: "neighborhood", value: "neighborhood" },
  { label: "address", value: "address" },
  { label: "postal_code", value: "postalCode" },
];
